import * as React from "react";
import './AnnotationResizers.css';
import {AnnotationDiv} from "PDFImporter/Manager/PDFManager/AnnotationDiv";
export class AnnotationResizers extends React.Component<AnnotationResizersProps, AnnotationResizersState> {
    static defaultProps: Partial<AnnotationResizersProps> = {};
    Direction:string;
    OriginalX:number;
    OriginalY:number;

    constructor(props: AnnotationResizersProps) {
        super(props);
        this.state = {};
        this.ResizeMove=this.ResizeMove.bind(this);
        this.ResizeEnd=this.ResizeEnd.bind(this);
    }

    public render() {
        return (
            <React.Fragment>
                <div className={'rnAResizeItem'} style={{top:-3,left:-3,cursor:'se-resize'}} onMouseDown={e=>this.StartResizing(e,'top-left')} onClick={e=>{e.stopPropagation();e.preventDefault()}}/>
                <div className={'rnAResizeItem'} style={{top:-3,left:'calc(50% - 3px)',cursor:'ns-resize'}} onMouseDown={e=>this.StartResizing(e,'top')}  onClick={e=>{e.stopPropagation();e.preventDefault()}}/>
                <div className={'rnAResizeItem'} style={{top:-3,right:-3,cursor:'sw-resize'}} onMouseDown={e=>this.StartResizing(e,'top-right')}/>

                <div className={'rnAResizeItem'} style={{top:'calc(50% - 3px)',left:-3,cursor:'ew-resize'}} onMouseDown={e=>this.StartResizing(e,'left')}  onClick={e=>{e.stopPropagation();e.preventDefault()}}/>
                <div className={'rnAResizeItem'} style={{top:'calc(50% - 3px)',right:-3,cursor:'ew-resize'}} onMouseDown={e=>this.StartResizing(e,'right')}  onClick={e=>{e.stopPropagation();e.preventDefault()}}/>


                <div className={'rnAResizeItem'} style={{bottom:-3,left:-3,cursor:'sw-resize'}} onMouseDown={e=>this.StartResizing(e,'bottom-left')}  onClick={e=>{e.stopPropagation();e.preventDefault()}}/>
                <div className={'rnAResizeItem'} style={{bottom:-3,left:'calc(50% - 3px)',cursor:'ns-resize'}} onMouseDown={e=>this.StartResizing(e,'bottom')}  onClick={e=>{e.stopPropagation();e.preventDefault()}}/>
                <div className={'rnAResizeItem'} style={{bottom:-3,right:-3,cursor:'se-resize'}} onMouseDown={e=>this.StartResizing(e,'bottom-right')}  onClick={e=>{e.stopPropagation();e.preventDefault()}}/>
            </React.Fragment>
        )
    }

    public StartResizing(e:React.MouseEvent, direction:string)
    {
        e.stopPropagation();
        e.preventDefault();
        this.Direction=direction;
        this.OriginalX=e.pageX;
        this.OriginalY=e.pageY;


        document.addEventListener('mousemove',this.ResizeMove);
        document.addEventListener('mouseup',this.ResizeEnd);

    }

    public ResizeMove(e:MouseEvent)
    {
        e.preventDefault();
        e.stopPropagation();
        let {x,y,width,height}=this.ComputeDimension(e);

        if(y!==null)
            this.props.AnnotationDiv.Div.style.top=y+'px';

        if(height!==null)
            this.props.AnnotationDiv.Div.style.height=height+'px';

        if(width!=null)
            this.props.AnnotationDiv.Div.style.width=width+'px';

        if(x!=null)
            this.props.AnnotationDiv.Div.style.left=x+'px';

    }

    public ResizeEnd(e:MouseEvent)
    {
        this.props.AnnotationDiv.props.AnnotationManager.ResizeTo(parseFloat(this.props.AnnotationDiv.Div.style.width),parseFloat(this.props.AnnotationDiv.Div.style.height),true);
        this.props.AnnotationDiv.props.AnnotationManager.MoveTo(parseFloat(this.props.AnnotationDiv.Div.style.left),parseFloat(this.props.AnnotationDiv.Div.style.top),false);


        document.removeEventListener('mousemove',this.ResizeMove);
        document.removeEventListener('mouseup',this.ResizeEnd);
    }

    private ComputeDimension(e: MouseEvent) {
        let x=null;
        let y=null;
        let width=null;
        let height=null;
        let newY=e.pageY;
        let newX=e.pageX;
        let div=this.props.AnnotationDiv.Div;
        let divBounds=this.props.AnnotationDiv.Div.getBoundingClientRect();
        let bounds=this.props.AnnotationDiv.props.AnnotationManager.Page.DocumentManager.Canvas.getBoundingClientRect();

        if(this.Direction.indexOf('top')>=0)
        {
            let newTop=e.pageY;

            if(newTop>divBounds.bottom-10)
                newTop=divBounds.bottom-10;

            newTop-=bounds.y;
            let oldTop=parseFloat(div.style.top);
            height=(divBounds.height+oldTop-newTop);
            y=newTop;
        }

        if(this.Direction.indexOf('bottom')>=0)
        {
            let newBottom=e.pageY-bounds.y;
            height=newBottom-(divBounds.top-bounds.y);
        }

        if(this.Direction.indexOf('left')>=0)
        {
            let newLeft=e.pageX;

            if(newLeft>divBounds.right-10)
                newLeft=divBounds.right-10;

            newLeft-=bounds.x;


            width=divBounds.right-newLeft-bounds.left;



            x=newLeft;
        }

        if(this.Direction.indexOf('right')>=0)
        {
            let newRight=e.pageX-bounds.x;
            width=newRight-(divBounds.left-bounds.x);
        }

        return {
            x:x?.toFixed(0),
            y:y?.toFixed(0),
            width:width?.toFixed(0),
            height:height?.toFixed(0)
        }


    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface AnnotationResizersProps {
    AnnotationDiv:AnnotationDiv;
}

interface AnnotationResizersState {

}

//#endregion "My Region"